var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container",attrs:{"id":"map"}},[_c('GoogleMap',{key:_vm.key,attrs:{"markers":_vm.mapMarkers,"center":_vm.mapCenter,"initialCenter":_vm.mapCenter},on:{"marker-click":_vm.handleMarkerClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }